import { Alert, Box, LinearProgress } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import Section from './section';
import axios from 'axios';
import {
  OrganisationSettings,
} from '../../../interfaces/delivery-company/orders';
import { API_ENDPOINT } from '../../../configurations/global.config';
import Grid2 from '@mui/material/Unstable_Grid2';
import { emptyOrgSettings } from '../../../data/settings';
import InvoiceSettlementConfig from './invoice-settlement-config/invoice-settlement-config';
import CriticalOrderCreditConfig from './critical-order-credit-config/critical-order-credit-config';
import InvoiceFrequencyConfig from './invoice-frequency-config/invoice-frequency-config';

function Pricing() {
  const { config } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>();
  const [orgSettings, setOrgSettings] = useState<OrganisationSettings>(emptyOrgSettings);

  useEffect(() => {
    const fetchOrgSettings = async () => {
      try {
        const response = await axios.get<OrganisationSettings>(
          `${API_ENDPOINT}/api/v1/settings`,
          config
        );
        setOrgSettings(response.data);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setError('Failed to load organisation settings: ' + e.message);
        } else {
          setError('Failed to load organisation settings');
        }
        console.log(e);
      }

      setLoading(false);
    };

    fetchOrgSettings();
  }, []);

  return (
    <Box>
      {loading ? (
        <LinearProgress />
      ) : (
        <>
          {error ? (
            <Alert severity="error">{error}</Alert>
          ) : (
            <>
              <Grid2 spacing={3} container alignItems="stretch">
                <Grid2 xs={12} md={6} display="flex">
                  <Section title="Invoice Settlement">
                    <InvoiceSettlementConfig settings={orgSettings} />
                  </Section>
                </Grid2>

                <Grid2 xs={12} md={6} display="flex">
                  <Section title="Critical Order Credit System">
                    <CriticalOrderCreditConfig settings={orgSettings} />
                  </Section>
                </Grid2>

                <Grid2 xs={12} md={4} display="flex">
                  <Section title="Invoice Frequency Extra Charges">
                    <InvoiceFrequencyConfig settings={orgSettings} />
                  </Section>
                </Grid2>
              </Grid2>
            </>
          )}
        </>
      )}
    </Box>
  );
}

export default Pricing;
